import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `Home di ${ctx.brand}`,
    languageButtonLabel: `Lingua`,
    languageModalTitle: `Scegli una lingua`,
    languageModalCloseLabel: `Chiudi il menu lingue`,
  },
  languageOptions: {
    'en-US': {
      label: `Inglese`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Inglese (Kenya)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Inglese (Nigeria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Inglese (Singapore)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Portoghese`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Português (Brasil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Tedesco`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Deutsch (Österreich)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Deutsch (Schweiz)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Spagnolo`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Francese`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Italiano`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Olandese`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polski`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Nordico & Baltico`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dansk`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Suomi`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norsk`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Íslenska`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Giapponese`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Coreano`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Mandarino`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Cantonese`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Tiếng Việt`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Thai`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Bahasa Indonesia`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Kiswahili`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Hindi`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `বাংলা`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `मराठी`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `తెలుగు`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Farsi`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `اردو`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `پنجابی`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Naijá Pidgin`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Russo`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Arabo`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `العربية (الإمارات)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `العربية (قطر)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Arabo marocchino`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Türkçe`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Scegli una lingua`,
    closeLabel: `Chiudi il menu lingue`,
  },
  languageHint: (ctx) => `Passa tra più di ${ctx.localesCount}+ lingue.`,
  readPagePrompt: ({languageLabel}) => `Leggi questa pagina in ${languageLabel}.`,
};
